import React, { useState, useEffect } from 'react';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Container,
  Row,
  Col,
} from 'reactstrap';

const PhotoBookEmailAccountSearch = ({ macAddress: macAddressProp = '', onButtonClick }) => {
  const [macAddress, setMacAddress] = useState(macAddressProp);

  useEffect(() => setMacAddress(macAddressProp), [macAddressProp]);

  const handleClick = (e) => {
    e.preventDefault();
    if (macAddressProp !== macAddress) {
      onButtonClick(macAddress);
    }
  };

  return (
    <Form onSubmit={handleClick}>
      <FormGroup>
        <Label><b>Mac Address Lovebox:</b></Label>
        <Container>
          <Row>
            <Col>
              <Input
                type="text"
                placeholder="Lovebox mac address"
                value={macAddress}
                onChange={({ target: { value } }) => setMacAddress(value)}
              />
            </Col>
            <Col>
              <Button
                type="submit"
                color="primary"
              >
                Search
              </Button>
            </Col>
          </Row>
        </Container>
      </FormGroup>
    </Form>
  );
};

export { PhotoBookEmailAccountSearch };



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/form/photobook-email-account.js